import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { Container } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { rootStyles } from '../themeStyles'
import isEqual from 'lodash/isEqual'
import { STEP_SMB_ORDER_FLOW_COBRAND_CARDS } from '../../../../containers/SMBOrderFlow'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({ ...rootStyles }))

const Layout = ({ children, baseUrl, brandLogoUrl, footerContent, step }) => {
    const classes = useStyles()
    const cobrandBuilderStep = useSelector(
        (state) => state.smbCart.cobrandBuilderStep
    )

    return (
        <>
            <Header step={step} baseUrl={baseUrl} logoImage={brandLogoUrl} />
            <Container
                className={
                    (isEqual(step, STEP_SMB_ORDER_FLOW_COBRAND_CARDS) &&
                        cobrandBuilderStep === -1) ||
                    cobrandBuilderStep === null
                        ? classes.cobrandCardsLandingPageRoot
                        : isEqual(step, STEP_SMB_ORDER_FLOW_COBRAND_CARDS) &&
                          cobrandBuilderStep >= 0
                        ? classes.cobrandBuilderRoot
                        : classes.root
                }
                maxWidth="lg"
            >
                {children}
            </Container>
            <Footer baseUrl={baseUrl} content={footerContent} />
        </>
    )
}

export default Layout
